import { useMemo } from 'react';

import { FileType } from 'services/file.service';
import { StoryBoardTracks } from 'services/storyboard.service';
import { useAppSelector } from 'store/store-hooks';
import { getVideoUrl, selectClipData } from 'components/app/_helpers/_app.helper';

interface Props {
  preview: boolean;
  isTitle: boolean;
}

export const __Preview = ({ preview, isTitle }: Props) => {
  const storyBoard = useAppSelector((state) => state.editor.storyBoard);
  const clipsMap = useAppSelector((state) => state.editor.clipsMap);
  const files = useAppSelector((state) => state.app__files.files);

  const previewData = useMemo(() => {
    if (!preview || !clipsMap) return;
    const clipId = storyBoard[StoryBoardTracks.storyBoard].at(isTitle ? 0 : -1);
    const clipData = clipId && selectClipData(clipId, clipsMap);
    const url = clipData && getVideoUrl(files[clipData.mediaFileId]);
    if (url) return { url, isImg: files[clipData.mediaFileId].fileType === FileType.image };
  }, [preview, clipsMap, storyBoard, files]);

  if (!previewData) return;

  return previewData.isImg ? <img src={previewData.url} /> : <video src={previewData.url} />;
};
